module.exports = __webpack_public_path__ + "static/img/9.8c9c91e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/9.png
// module id = VPUV
// module chunks = 0